import React, { Component } from "react"
import TableUsuarios from "./TableUsuarios"
import * as ApiHelper from "../../ApiHelper"
import { Loading, HttpError } from "../../components"
import Layout from "../Layout"
export default class Usuarios extends Component {
  constructor() {
    super()
    this.getUsuarios = this.getUsuarios.bind(this)
    this.didDelete = this.didDelete.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { usuarios: [], initialUsuarios: [], showTable: false }
  }
  componentWillMount() {
    this.getUsuarios()
  }
  getUsuarios() {
    ApiHelper.getUsuarios((usuarios, error) => {
      if (usuarios) {
        this.setState({
          usuarios: usuarios,
          initialUsuarios: usuarios,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  didDelete() {
    this.getUsuarios()
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialUsuarios.filter(usuario => {
      return (
        usuario.name.toLowerCase().search(searchText) !== -1 ||
        usuario.cpf.toLowerCase().search(searchText) !== -1 ||
        usuario.email.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      usuarios: filtered
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Operadores">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Operadores">
        {this.state.showTable ? (
          <TableUsuarios
            filter={this.filter}
            onDelete={this.didDelete}
            sizeClass=""
            title="Operadores do sistema"
            subtitle={"Listagem de todos os operadores do sistema"}
            backgroundColor="as-blue"
            rows={this.state.usuarios}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/usuarios/Usuarios.js